import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';

import { GraphService } from 'src/app/shared/lib/api/graph.service';
import { GET_EGRESO_PROOFS_OF_PAYMENT } from '../graphql/egreso.queries';

export interface SentProofBadge {
  id: string;
  actor: string;
  sentAt?: string;
}

interface ProofOfPaymentLite {
  id?: string;
  mailSent?: boolean;
  mailSentBy?: string;
  mailSentByEmail?: string;
  mailSentAt?: string;
  isDeleted?: boolean;
}

interface EgresoProofsResponse {
  getEgresoDetalleConstancia?: {
    id?: string;
    tipoOrden?: string;
    proofsOfPayment?: ProofOfPaymentLite[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class EgresoProofsOfPaymentService {
  private readonly graphQL = inject(GraphService);

  private resolveActorName(mailSentBy?: string, mailSentByEmail?: string): string {
    const senderName = String(mailSentBy ?? '').trim();
    if (senderName) {
      return senderName;
    }

    const senderEmail = String(mailSentByEmail ?? '').trim();
    if (senderEmail) {
      return senderEmail;
    }

    return 'Usuario no mapeado';
  }

  getSentProofBadges(egresoId: string): Observable<SentProofBadge[]> {
    return this.graphQL.queryGraphQL<EgresoProofsResponse>({
      query: GET_EGRESO_PROOFS_OF_PAYMENT,
      variables: { id: egresoId },
    }).pipe(
      map((response) => response?.getEgresoDetalleConstancia?.proofsOfPayment ?? []),
      map((proofs) =>
        proofs
          .filter((proof) => Boolean(proof?.id) && Boolean(proof?.mailSent))
          // Comprobar si trae la propiedad isDeleted para excluir comprobantes eliminados. Si no la trae, se asume que no están eliminados
          .filter((proof) => proof?.isDeleted !== true)
          .map((proof) => ({
            id: String(proof.id),
            actor: this.resolveActorName(proof.mailSentBy, proof.mailSentByEmail),
            sentAt: proof.mailSentAt,
          }))
      )
    );
  }
}
